import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Instagram = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0-2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm6.5-.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM12 4c-2.47 0-2.88 0-4.03.06-.78.04-1.3.14-1.8.33-.43.17-.74.37-1.08.7-.31.3-.55.67-.7 1.08-.2.5-.3 1.02-.33 1.8A69.2 69.2 0 0 0 4 12c0 2.47 0 2.88.06 4.03.04.78.14 1.3.33 1.8.17.43.37.74.7 1.08.34.33.65.53 1.08.7.5.19 1.02.3 1.8.33 1.1.05 1.5.06 4.03.06 2.47 0 2.88 0 4.03-.06.78-.04 1.3-.14 1.8-.33.43-.17.74-.37 1.08-.7.33-.34.53-.65.7-1.08.19-.5.3-1.02.33-1.8.05-1.1.06-1.5.06-4.03 0-2.47 0-2.88-.06-4.03a5.44 5.44 0 0 0-.33-1.8c-.15-.4-.4-.77-.7-1.08-.3-.31-.67-.55-1.08-.7a5.43 5.43 0 0 0-1.8-.33A69.2 69.2 0 0 0 12 4Zm0-2c2.72 0 3.06.01 4.12.06 1.07.05 1.8.22 2.43.46.66.26 1.22.6 1.77 1.16.51.5.9 1.1 1.16 1.77.24.64.41 1.36.46 2.43.05 1.06.06 1.4.06 4.12s-.01 3.06-.06 4.12a7.4 7.4 0 0 1-.46 2.43 4.88 4.88 0 0 1-1.16 1.77c-.5.51-1.1.9-1.77 1.16-.64.24-1.36.41-2.43.46-1.06.05-1.4.06-4.12.06s-3.06-.01-4.12-.06a7.4 7.4 0 0 1-2.43-.46 4.89 4.89 0 0 1-1.77-1.16c-.51-.5-.9-1.1-1.16-1.77a7.36 7.36 0 0 1-.46-2.43C2.01 15.06 2 14.72 2 12s.01-3.06.06-4.12c.05-1.07.22-1.8.46-2.43.26-.67.65-1.27 1.16-1.77.5-.51 1.1-.9 1.77-1.16a7.36 7.36 0 0 1 2.43-.46C8.94 2.01 9.28 2 12 2Z"
    />
  </svg>
));
